var CountryPicker = {
    setCountryCookie : function (cvalue) {
        var d = new Date();
        d.setTime(d.getTime() + (31 * 24 * 60 * 60 * 1000)); //TODO - define expiration time
        var expires = "expires=" + d.toUTCString();
        document.cookie = "CountryId" + "=" + cvalue + ";" + expires + ";path=/";
    }
}

